import type { FunctionComponent } from 'react'
import { useMemo } from 'react'

import tourV2VerticalNameSelector from 'selectors/TourV2/tourV2VerticalNameSelector'
import GlobalHotelsSearchTabContent from 'components/Search/GlobalSearch/GlobalSearchVerticalsTabContents/GlobalHotelsSearchTabContent'
import GlobalHomesAndVillasSearchTabContent from 'components/Search/GlobalSearch/GlobalSearchVerticalsTabContents/GlobalHomesAndVillasSearchTabContent'
import GlobalTourSearchTabContent from 'components/Search/GlobalSearch/GlobalSearchVerticalsTabContents/GlobalTourSearchTabContent'
import GlobalExperiencesSearchTabContent from 'components/Search/GlobalSearch/GlobalSearchVerticalsTabContents/GlobalExperiencesSearchTabContent'
import GlobalFlightsSearchTabContent from 'components/Search/GlobalSearch/GlobalSearchVerticalsTabContents/GlobalFlightsSearchTabContent'
import GlobalCruisesSearchTabContent from 'components/Search/GlobalSearch/GlobalSearchVerticalsTabContents/GlobalCruisesSearchTabContent'
import GlobalCarHireSearchTabContent from 'components/Search/GlobalSearch/GlobalSearchVerticalsTabContents/GlobalCarHireSearchTabContent'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineHomeAltIcon from 'LuxKit/Icons/line/LineHomeAltIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineHotAirBalloonIcon from 'LuxKit/Icons/line/LineHotAirBalloonIcon'
import { useAppSelector } from 'hooks/reduxHooks'
import LineShopIcon from 'LuxKit/Icons/line/LineShopIcon'
import GlobalMerchandiseSearchTabContent from 'components/Search/GlobalSearch/GlobalSearchVerticalsTabContents/GlobalMerchandiseSearchTabContent'
import { arrayToMap } from 'lib/array/arrayUtils'
import useGlobalSearchVerticals from './useGlobalSearchVerticals'

const SEARCH_VERTICALS_TAB_COMPONENTS: Record<App.SearchVertical, FunctionComponent> = {
  'car-hire': GlobalCarHireSearchTabContent,
  cruises: GlobalCruisesSearchTabContent,
  experiences: GlobalExperiencesSearchTabContent,
  flights: GlobalFlightsSearchTabContent,
  'homes-and-villas': GlobalHomesAndVillasSearchTabContent,
  hotels: GlobalHotelsSearchTabContent,
  tours: GlobalTourSearchTabContent,
  merchandise: GlobalMerchandiseSearchTabContent,
}

const SEARCH_VERTICALS_TAB_ICONS: Record<App.SearchVertical, FunctionComponent> = {
  'car-hire': LineCarIcon,
  cruises: LineShipIcon,
  experiences: LineHotAirBalloonIcon,
  flights: LinePlaneDepartureIcon,
  'homes-and-villas': LineHomeAltIcon,
  hotels: LineBedIcon,
  tours: LineCompassIcon,
  merchandise: LineShopIcon,
}

function useGlobalSearchVerticalTabs(): Map<App.SearchVertical, App.GlobalSearchVerticalTab> {
  const verticals = useGlobalSearchVerticals()
  const toursVerticalName = useAppSelector((state) => tourV2VerticalNameSelector(state)).toLowerCase()

  const globalSearchVerticals = useMemo(() => {
    return arrayToMap(
      verticals,
      vertical => vertical.vertical,
      (vertical) => {
        return {
          id: vertical.vertical,
          label: vertical.vertical === 'tours' ? toursVerticalName : vertical.label,
          Component: SEARCH_VERTICALS_TAB_COMPONENTS[vertical.vertical],
          Icon: SEARCH_VERTICALS_TAB_ICONS[vertical.vertical],
        }
      })
  }, [verticals, toursVerticalName])

  return globalSearchVerticals
}

export default useGlobalSearchVerticalTabs
